import { render, staticRenderFns } from "./VideoCallDispatch.vue?vue&type=template&id=744270ac&scoped=true&"
import script from "./VideoCallDispatch.vue?vue&type=script&lang=ts&"
export * from "./VideoCallDispatch.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallDispatch.vue?vue&type=style&index=0&id=744270ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744270ac",
  null
  
)

export default component.exports